import PropTypes from 'prop-types';
import React from 'react';
import CSSModules from 'react-css-modules';
import styles from './Featured.less';
import FeaturedNow from './FeaturedNow';
import FeaturedCarousel from './FeaturedCarousel';
import FeaturedFilter from './FeaturedFilter';
import FeaturedPages from './FeaturedPages';

const Featured = ({
  carouselPages,
  filteredPages,
  filter,
  isLoading,
  loadMorePages,
  changeFilter,
  activePagesCount,
  avatars,
  loadAvatars,
  selectCard,
  slideCarousel,
}) => (
  <section styleName="container">
    <div className="dna-grid-container">
      <div className="dna-grid-row" styleName="body">
        <FeaturedNow activePagesCount={activePagesCount} />
        <FeaturedFilter filter={filter} onChange={changeFilter} />
        <FeaturedCarousel
          visible={filter.typeId === 0 && carouselPages.length >= 5}
          pages={carouselPages}
          avatars={avatars}
          loadAvatars={loadAvatars}
          selectCard={selectCard}
          slideCarousel={slideCarousel}
        />
        <FeaturedPages
          pages={filteredPages}
          isLoading={isLoading}
          filter={filter}
          loadMore={loadMorePages}
          avatars={avatars}
          loadAvatars={loadAvatars}
          selectCard={selectCard}
        />
      </div>
    </div>
  </section>
);

Featured.propTypes = {
  carouselPages: PropTypes.arrayOf(
    PropTypes.shape({
      projectType: PropTypes.string.isRequired,
      targetCurrency: PropTypes.string.isRequired,
      amountRaised: PropTypes.number.isRequired,
      progress: PropTypes.number.isRequired,
      pitch: PropTypes.string.isRequired,
      owner: PropTypes.string.isRequired,
      numberOfSupporters: PropTypes.number.isRequired,
      projectId: PropTypes.string.isRequired,
      projectUrl: PropTypes.string.isRequired,
      projectImage: PropTypes.shape({
        url: PropTypes.string,
        width: PropTypes.number,
        height: PropTypes.number,
        cropArea: PropTypes.shape({
          top: PropTypes.number,
          left: PropTypes.number,
          width: PropTypes.number,
          height: PropTypes.number,
        }),
      }),
    }).isRequired
  ).isRequired,
  filteredPages: PropTypes.shape({
    totalCount: PropTypes.number.isRequired,
    pageNo: PropTypes.number.isRequired,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        projectType: PropTypes.string.isRequired,
        targetCurrency: PropTypes.string.isRequired,
        amountRaised: PropTypes.number.isRequired,
        progress: PropTypes.number.isRequired,
        pitch: PropTypes.string.isRequired,
        owner: PropTypes.string.isRequired,
        numberOfSupporters: PropTypes.number.isRequired,
        projectId: PropTypes.string.isRequired,
        projectUrl: PropTypes.string.isRequired,
        projectImage: PropTypes.shape({
          url: PropTypes.string,
          width: PropTypes.number,
          height: PropTypes.number,
          cropArea: PropTypes.shape({
            top: PropTypes.number,
            left: PropTypes.number,
            width: PropTypes.number,
            height: PropTypes.number,
          }),
        }),
      }).isRequired
    ).isRequired,
  }).isRequired,
  filter: PropTypes.shape({
    categoryId: PropTypes.number.isRequired,
    typeId: PropTypes.number.isRequired,
    locationId: PropTypes.number.isRequired,
  }),
  isLoading: PropTypes.bool.isRequired,
  loadMorePages: PropTypes.func.isRequired,
  changeFilter: PropTypes.func.isRequired,
  activePagesCount: PropTypes.number.isRequired,
  avatars: PropTypes.objectOf(PropTypes.string),
  loadAvatars: PropTypes.func.isRequired,
  selectCard: PropTypes.func.isRequired,
  slideCarousel: PropTypes.func.isRequired,
};

export default CSSModules(Featured, styles);



// WEBPACK FOOTER //
// ./src/components/Home/Featured.js